export enum SystemAuthorizations {
  AreacircolazioneAdd = 'AREACIRCOLAZIONE.ADD',
  AreacircolazioneDelete = 'AREACIRCOLAZIONE.DELETE',
  AreacircolazioneQuery = 'AREACIRCOLAZIONE.QUERY',
  AreacircolazioneUpdate = 'AREACIRCOLAZIONE.UPDATE',
  CivicoAdd = 'CIVICO.ADD',
  CivicoDelete = 'CIVICO.DELETE',
  CivicoQuery = 'CIVICO.QUERY',
  CivicoUpdate = 'CIVICO.UPDATE',
  ComuneAdd = 'COMUNE.ADD',
  ComuneDelete = 'COMUNE.DELETE',
  ComuneQuery = 'COMUNE.QUERY',
  ComuneUpdate = 'COMUNE.UPDATE',
  ConsolatoAdd = 'CONSOLATO.ADD',
  ConsolatoDelete = 'CONSOLATO.DELETE',
  ConsolatoQuery = 'CONSOLATO.QUERY',
  ConsolatoUpdate = 'CONSOLATO.UPDATE',
  EnteAdd = 'ENTE.ADD',
  EnteDelete = 'ENTE.DELETE',
  EnteQuery = 'ENTE.QUERY',
  EnteUpdate = 'ENTE.UPDATE',
  ErrorQuery = 'ERROR_DLQ.QUERY',
  FunzioneAdd = 'FUNZIONE.ADD',
  FunzioneDelete = 'FUNZIONE.DELETE',
  FunzioneQuery = 'FUNZIONE.QUERY',
  FunzioneUpdate = 'FUNZIONE.UPDATE',
  GruppoAdd = 'GRUPPO.ADD',
  GruppoDelete = 'GRUPPO.DELETE',
  GruppoQuery = 'GRUPPO.QUERY',
  GruppoUpdate = 'GRUPPO.UPDATE',
  MunicipioAdd = 'MUNICIPIO.ADD',
  MunicipioDelete = 'MUNICIPIO.DELETE',
  MunicipioQuery = 'MUNICIPIO.QUERY',
  MunicipioUpdate = 'MUNICIPIO.UPDATE',
  OperatoreAdd = 'OPERATORE.ADD',
  OperatoreDelete = 'OPERATORE.DELETE',
  OperatoreQuery = 'OPERATORE.QUERY',
  OperatoreUpdate = 'OPERATORE.UPDATE',
  ProfiloAdd = 'PROFILO.ADD',
  ProfiloDelete = 'PROFILO.DELETE',
  ProfiloQuery = 'PROFILO.QUERY',
  ProfiloUpdate = 'PROFILO.UPDATE',
  NumeratoreAdd = 'NUMERATORE.ADD',
  NumeratoreDelete = 'NUMERATORE.DELETE',
  NumeratoreQuery = 'NUMERATORE.QUERY',
  NumeratoreUpdate = 'NUMERATORE.UPDATE',
  ProvinciaAdd = 'PROVINCIA.ADD',
  ProvinciaDelete = 'PROVINCIA.DELETE',
  ProvinciaQuery = 'PROVINCIA.QUERY',
  ProvinciaUpdate = 'PROVINCIA.UPDATE',
  QualificaAdd = 'QUALIFICA.ADD',
  QualificaDelete = 'QUALIFICA.DELETE',
  QualificaQuery = 'QUALIFICA.QUERY',
  QualificaUpdate = 'QUALIFICA.UPDATE',
  RegioneAdd = 'REGIONE.ADD',
  RegioneDelete = 'REGIONE.DELETE',
  RegioneQuery = 'REGIONE.QUERY',
  RegioneUpdate = 'REGIONE.UPDATE',
  ServizioAdd = 'SERVIZIO.ADD',
  ServizioDelete = 'SERVIZIO.DELETE',
  ServizioQuery = 'SERVIZIO.QUERY',
  ServizioUpdate = 'SERVIZIO.UPDATE',
  StatoesteroAdd = 'STATOESTERO.ADD',
  StatoesteroDelete = 'STATOESTERO.DELETE',
  StatoesteroQuery = 'STATOESTERO.QUERY',
  StatoesteroUpdate = 'STATOESTERO.UPDATE',
  TerritorioAdd = 'TERRITORIO.ADD',
  TerritorioDelete = 'TERRITORIO.DELETE',
  TerritorioQuery = 'TERRITORIO.QUERY',
  TerritorioUpdate = 'TERRITORIO.UPDATE',
  TipoFeatureValoreQuery = 'TIPO_FEATURE_VALORE.QUERY',
  TipoFeatureValoreAdd = 'TIPO_FEATURE_VALORE.ADD',
  TipoFeatureValoreUpdate = 'TIPO_FEATURE_VALORE.UPDATE',
  TipoFeatureValoreDelete = 'TIPO_FEATURE_VALORE.DELETE',
  TipoFeatureAuthQuery = 'AUTORIZZAZIONE.QUERY',
  TipoFeatureAuthAdd = 'AUTORIZZAZIONE.ADD',
  TipoFeatureAuthUpdate = 'AUTORIZZAZIONE.UPDATE',
  TipoFeatureAuthDelete = 'AUTORIZZAZIONE.DELETE',
  BatchAdmin = 'ADMIN_BATCH',
  BatchManagementQuery = 'ADMIN_BATCH',
  BatchManagementAdd = 'ADMIN_BATCH',
  BatchManagementUpdate = 'ADMIN_BATCH',
  BatchManagementDelete = 'ADMIN_BATCH',
  CertificatoPostazioneAnprAdd = 'CERTIFICATO.POSTAZIONE.ADD',
  CertificatoPostazioneAnprDelete = 'CERTIFICATO.POSTAZIONE.DELETE',
  CertificatoPostazioneAnprQuery = 'CERTIFICATO.POSTAZIONE.QUERY',
  CertificatoPostazioneAnprUpdate = 'CERTIFICATO.POSTAZIONE.UPDATE',
  TipoEventoAdd = 'ADMIN_EVTMGR',
  TipoEventoDelete = 'ADMIN_EVTMGR',
  TipoEventoQuery = 'ADMIN_EVTMGR',
  TipoEventoUpdate = 'ADMIN_EVTMGR',
  TipoDestinazioneAdd = 'ADMIN_EVTMGR',
  TipoDestinazioneDelete = 'ADMIN_EVTMGR',
  TipoDestinazioneQuery = 'ADMIN_EVTMGR',
  TipoDestinazioneUpdate = 'ADMIN_EVTMGR',
  SottoscrittoreAdd = 'ADMIN_EVTMGR',
  SottoscrittoreDelete = 'ADMIN_EVTMGR',
  SottoscrittoreQuery = 'ADMIN_EVTMGR',
  SottoscrittoreUpdate = 'ADMIN_EVTMGR',
  IscrizioneEventoAdd = 'ADMIN_EVTMGR',
  IscrizioneEventoDelete = 'ADMIN_EVTMGR',
  IscrizioneEventoQuery = 'ADMIN_EVTMGR',
  IscrizioneEventoUpdate = 'ADMIN_EVTMGR',
  EventoQuery = 'ADMIN_EVTMGR',
  EventoErrQuery = 'ADMIN_EVTMGR',
  PecQuery = 'PEC.QUERY',
}

export const ConsulateAuthorization = [
  SystemAuthorizations.ConsolatoAdd,
  SystemAuthorizations.ConsolatoDelete,
  SystemAuthorizations.ConsolatoUpdate,
];

export const MunicipalityAuthorization = [
  SystemAuthorizations.ComuneAdd,
  SystemAuthorizations.ComuneQuery,
  SystemAuthorizations.ComuneDelete,
  SystemAuthorizations.ComuneUpdate,
];

export const TerritoryAuthorization = [
  SystemAuthorizations.TerritorioAdd,
  SystemAuthorizations.TerritorioQuery,
  SystemAuthorizations.TerritorioDelete,
  SystemAuthorizations.TerritorioUpdate,
];

export const ForeignStateAuthorization = [
  SystemAuthorizations.StatoesteroAdd,
  SystemAuthorizations.StatoesteroQuery,
  SystemAuthorizations.StatoesteroDelete,
  SystemAuthorizations.StatoesteroUpdate,
];

export const ProvinceAuthorization = [
  SystemAuthorizations.ProvinciaAdd,
  SystemAuthorizations.ProvinciaQuery,
  SystemAuthorizations.ProvinciaDelete,
  SystemAuthorizations.ProvinciaUpdate,
];

export const RegionAuthorization = [
  SystemAuthorizations.RegioneAdd,
  SystemAuthorizations.RegioneQuery,
  SystemAuthorizations.RegioneDelete,
  SystemAuthorizations.RegioneUpdate,
];

export const ServiceAuthorization = [
  SystemAuthorizations.ServizioAdd,
  SystemAuthorizations.ServizioQuery,
  SystemAuthorizations.ServizioDelete,
  SystemAuthorizations.ServizioUpdate,
];

export const OperatorAuthorization = [
  SystemAuthorizations.OperatoreAdd,
  SystemAuthorizations.OperatoreQuery,
  SystemAuthorizations.OperatoreDelete,
  SystemAuthorizations.OperatoreUpdate,
];

export const CertificateAnprAuthorization = [
  SystemAuthorizations.CertificatoPostazioneAnprAdd,
  SystemAuthorizations.CertificatoPostazioneAnprQuery,
  SystemAuthorizations.CertificatoPostazioneAnprDelete,
  SystemAuthorizations.CertificatoPostazioneAnprUpdate,
];

export const ToponymyAuthorization = [
  SystemAuthorizations.AreacircolazioneAdd,
  SystemAuthorizations.AreacircolazioneQuery,
  SystemAuthorizations.AreacircolazioneDelete,
  SystemAuthorizations.AreacircolazioneUpdate,
];

export const InstitutionAuthorization = [
  SystemAuthorizations.EnteAdd,
  SystemAuthorizations.EnteQuery,
  SystemAuthorizations.EnteDelete,
  SystemAuthorizations.EnteUpdate,
];

export const QualificationAuthorization = [
  SystemAuthorizations.QualificaAdd,
  SystemAuthorizations.QualificaQuery,
  SystemAuthorizations.QualificaDelete,
  SystemAuthorizations.QualificaUpdate,
];

export const TownHallAuthorization = [
  SystemAuthorizations.MunicipioAdd,
  SystemAuthorizations.MunicipioQuery,
  SystemAuthorizations.MunicipioDelete,
  SystemAuthorizations.MunicipioUpdate,
];

export const GroupAuthorization = [
  SystemAuthorizations.GruppoAdd,
  SystemAuthorizations.GruppoQuery,
  SystemAuthorizations.GruppoDelete,
  SystemAuthorizations.GruppoUpdate,
];

export const ProfileAuthorization = [
  SystemAuthorizations.ProfiloAdd,
  SystemAuthorizations.ProfiloQuery,
  SystemAuthorizations.ProfiloDelete,
  SystemAuthorizations.ProfiloUpdate,
];

export const NumeratorAuthorization = [
  SystemAuthorizations.NumeratoreAdd,
  SystemAuthorizations.NumeratoreQuery,
  SystemAuthorizations.NumeratoreDelete,
  SystemAuthorizations.NumeratoreUpdate,
];

export const CivicAuthorization = [
  SystemAuthorizations.CivicoAdd,
  SystemAuthorizations.CivicoQuery,
  SystemAuthorizations.CivicoDelete,
  SystemAuthorizations.CivicoUpdate,
];

export const FeatureAuthValueAuthorization = [
  SystemAuthorizations.TipoFeatureValoreAdd,
  SystemAuthorizations.TipoFeatureValoreQuery,
  SystemAuthorizations.TipoFeatureValoreDelete,
  SystemAuthorizations.TipoFeatureValoreUpdate,
];

export const EventTypeAuthorization = [
  SystemAuthorizations.TipoEventoAdd,
  SystemAuthorizations.TipoEventoQuery,
  SystemAuthorizations.TipoEventoDelete,
  SystemAuthorizations.TipoEventoUpdate,
];

export const DestinationTypeAuthorization = [
  SystemAuthorizations.TipoDestinazioneAdd,
  SystemAuthorizations.TipoDestinazioneDelete,
  SystemAuthorizations.TipoDestinazioneQuery,
  SystemAuthorizations.TipoDestinazioneUpdate,
];

export const SubscriberAuthorization = [
  SystemAuthorizations.SottoscrittoreAdd,
  SystemAuthorizations.SottoscrittoreDelete,
  SystemAuthorizations.SottoscrittoreQuery,
  SystemAuthorizations.SottoscrittoreUpdate,
];

export const EventRegistrationAuthorization = [
  SystemAuthorizations.IscrizioneEventoAdd,
  SystemAuthorizations.IscrizioneEventoDelete,
  SystemAuthorizations.IscrizioneEventoQuery,
  SystemAuthorizations.IscrizioneEventoUpdate,
];

export const SearchPublishedEventsAuthorization = [SystemAuthorizations.EventoQuery];

export const SearchErrorEventsAuthorization = [SystemAuthorizations.EventoErrQuery];

export const ManagementNonRecoverableErrorsAuthorization = [SystemAuthorizations.ErrorQuery];

export const GeographicAuthorizations = [
  ...MunicipalityAuthorization,
  ...ForeignStateAuthorization,
  ...ConsulateAuthorization,
  ...ProvinceAuthorization,
  ...RegionAuthorization,
];

export const EventAuthorizations = [
  ...EventTypeAuthorization,
  ...DestinationTypeAuthorization,
  ...SubscriberAuthorization,
  ...EventRegistrationAuthorization,
  ...SearchPublishedEventsAuthorization,
  ...SearchErrorEventsAuthorization,
];

export const TypeEventAuthorizations = [
  SystemAuthorizations.TipoEventoAdd,
  SystemAuthorizations.TipoEventoUpdate,
  SystemAuthorizations.TipoEventoQuery,
  SystemAuthorizations.TipoEventoDelete,
];
export const TypeDestinationAuthorizations = [
  SystemAuthorizations.TipoDestinazioneAdd,
  SystemAuthorizations.TipoDestinazioneDelete,
  SystemAuthorizations.TipoDestinazioneQuery,
  SystemAuthorizations.TipoDestinazioneUpdate,
];

export const FeatureAuthAuthorization = [
  SystemAuthorizations.TipoFeatureAuthAdd,
  SystemAuthorizations.TipoFeatureAuthDelete,
  SystemAuthorizations.TipoFeatureAuthQuery,
  SystemAuthorizations.TipoFeatureAuthUpdate,
];

export const BatchManagementAuthorization = [
  SystemAuthorizations.BatchManagementQuery,
  SystemAuthorizations.BatchManagementAdd,
  SystemAuthorizations.BatchManagementUpdate,
  SystemAuthorizations.BatchManagementDelete,
];

export const PecManagementAuthorization = [SystemAuthorizations.PecQuery];

export const ProcessingJobAuthorization = [SystemAuthorizations.BatchAdmin];

export const FunctionsAuthorization = GroupAuthorization.concat(ProfileAuthorization);

export const SystemAuthorizationsList = [
  ...ProfileAuthorization,
  ...TownHallAuthorization,
  ...InstitutionAuthorization,
  ...OperatorAuthorization,
  ...GroupAuthorization,
  ...QualificationAuthorization,
  ...ToponymyAuthorization,
  ...ServiceAuthorization,
  ...MunicipalityAuthorization,
  ...RegionAuthorization,
  ...ProvinceAuthorization,
  ...ForeignStateAuthorization,
  ...ManagementNonRecoverableErrorsAuthorization,
  ...EventAuthorizations,
  ...TerritoryAuthorization,
  ...ConsulateAuthorization,
  ...GeographicAuthorizations,
  ...ProcessingJobAuthorization,
  ...BatchManagementAuthorization,
  ...PecManagementAuthorization,
  ...NumeratorAuthorization,
];
